<template>
  <div class="checkIn weight">
    <mu-row class="content" style="align-items: center" gutter>
      <mu-col width="100" desktop="50" tablet="50" style="padding-right: 24px;">
        <div class="bigTxt first">HbA1c readings are a great way to mark your progress.</div>
        <div class="bigTxt">What was your last HbA1c result?</div>
      </mu-col>
      <mu-col width="100" desktop="50" tablet="50">
        <form novalidate @submit.prevent="submitForm">
          <mu-card style="width: 280px; margin: 0 auto;">
            <mu-card-text class="pad">
              <div class="lgTxt">My HbA1c is...</div>
              <mu-row align="center">
                <mu-col width="100" tablet="100" desktop="100"
                        v-if="$store.state.user.settings.hba1c.measure === 'percentage'">
                  <div class="shadow">
                    <input
                      min="0"
                      type="number"
                      class="input"
                      v-validate
                      data-vv-validate-on="none"
                      :data-vv-rules="'min_value:0|max_value:25'"
                      data-vv-name="hba1c_percent"
                      :data-vv-as="$store.state.user.settings.hba1c.unit"
                      v-model.number="model.percent"
                    />
                  </div>
                  <div class="label">
                    Percent (%)
                  </div>
                </mu-col>
                <mu-col width="100" tablet="100" desktop="100"
                        v-if="$store.state.user.settings.hba1c.measure === 'mmol-mol'">
                  <div class="shadow">
                    <input
                      min="0"
                      type="number"
                      class="input"
                      v-validate
                      :data-vv-rules="'min_value:0|max_value:300'"
                      data-vv-name="hba1c_mmol_mol"
                      :data-vv-as="$store.state.user.settings.hba1c.unit"
                      v-model.number="model.mmol_mol"
                    />
                  </div>
                  <div class="label">
                    mmol/mol
                  </div>
                </mu-col>
              </mu-row>
              <button type="submit" style="display: none;"></button>
              <mu-raised-button
                :disabled="isProcessing"
                type="button"
                @click.native="submitForm"
                style="margin-top: 16px;"
                :label="!isProcessing ? $t('message.nextText') : $t('message.savingText')"
                secondary fullWidth></mu-raised-button>
            </mu-card-text>
          </mu-card>
        </form>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import CheckInApi from '../../api/CheckIn';
  export default {
    data() {
      return {
        isProcessing: false,
        model: {}
      }
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isProcessing = true;
              CheckInApi.addHba1c(self.model)
                .then(function (response) {
                  self.$router.push({
                    name: 'GoalsCheckin'
                  })
                });
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Hba1c.vue?3b399410